import type { MessageKey } from "../../shared/i18n";

export type ChangeTileKind = "added" | "hidden" | "changed" | "blocked";

const ADDED_KEYS: ReadonlySet<MessageKey> = new Set<MessageKey>([
  "draft.changes.field_added",
  "draft.changes.field_shown",
  "draft.changes.option_added",
  "draft.changes.collection_added",
  "draft.changes.view_added",
  "draft.changes.control_added",
  "draft.changes.print_form_added",
]);

const HIDDEN_KEYS: ReadonlySet<MessageKey> = new Set<MessageKey>([
  "draft.changes.field_hidden",
  "draft.changes.control_removed",
]);

/** Which tile a change line gets: plus (added), x (hidden), pencil (changed). */
export function tileKindOf(messageKey: MessageKey): ChangeTileKind {
  if (ADDED_KEYS.has(messageKey)) return "added";
  if (HIDDEN_KEYS.has(messageKey)) return "hidden";
  return "changed";
}
